"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasketOfferTypes = void 0;
let BasketOfferTypes = exports.BasketOfferTypes = /*#__PURE__*/function (BasketOfferTypes) {
  BasketOfferTypes[BasketOfferTypes["BUY_WITH_DISCOUNT"] = 1] = "BUY_WITH_DISCOUNT";
  BasketOfferTypes[BasketOfferTypes["GET_BENEFIT"] = 2] = "GET_BENEFIT";
  BasketOfferTypes[BasketOfferTypes["CHOOSE_WITH_DISCOUNT"] = 3] = "CHOOSE_WITH_DISCOUNT";
  BasketOfferTypes[BasketOfferTypes["CHOOSE_AND_GET"] = 4] = "CHOOSE_AND_GET";
  BasketOfferTypes[BasketOfferTypes["CHOOSE_AND_CHOOSE"] = 5] = "CHOOSE_AND_CHOOSE";
  return BasketOfferTypes;
}({});
